module.exports = __webpack_public_path__ + "img/5-3.5428592f.png";